module.exports = __webpack_public_path__ + "media/smartz-clippingpod-en.92cd2a01.mp4";